module.exports = __webpack_public_path__ + "img/ltc.bab6dbf7.svg";